









import { Component, Vue } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';
import { Job } from '@/models/job.interface';
import JobCardInfo from '@/components/job/JobCardInfo.vue';

@Component({
  components: {
    JobCardInfo,
  },
})
export default class JobDetail extends Vue {
  @Getter public selectedJob!: Job;
  @Action('getJobAction') public getJobAction!: (id: string) => void;

  private mounted(): void {
    if (!this.selectedJob) {
      this.getJobAction(this.$route.params.id);
    }
  }
}
